import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CourseCssService {
  _width: number = 0
  get width(): number { return this._width }
  set width(value: number) { this._width = value; }
  constructor() { }

  responsiveClass(): string {
    if (this.width > 850) {
      return ''
    } else if ( this.width > 500) {
      return 'simplestack'
    } else {
      return 'mobile'
    }
  }

  responsiveClassNew(): string {
    if (this.width > 850) {
      return ''
    } else if ( this.width > 500) {
      return 'simplestack-new'
    } else {
      return 'mobile-new'
    }
  }
}
